(function () {
  'use strict';
  class Controller {}
  angular
    .module('actions')
    .component('productRemoveAction', {
      controller: Controller,
      templateUrl: 'actions/product/remove/remove-product.action.html',
      bindings: {
        productId: '<',
        then: '&',
        catch: '&'
      }
    });
}());
